var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.007,
    height: 18.983,
    viewBox: "0 0 20.007 18.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.997 -2.019)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.92,19.6l-1.59-3.68a7.45,7.45,0,0,0,.79-3.36A7.58,7.58,0,0,0,17,5.85,7.55,7.55,0,0,0,2.88,9.55a7.27,7.27,0,0,0,.79,3.37L2.08,16.6A1,1,0,0,0,3,18a1.14,1.14,0,0,0,.4-.08L7,16.35a7.53,7.53,0,0,0,9.88,3l3.68,1.59A1.14,1.14,0,0,0,21,21a1,1,0,0,0,.92-1.4ZM5.64,12.34a5.19,5.19,0,0,1-.76-2.78A5.56,5.56,0,0,1,15.4,7.05,5.65,5.65,0,0,1,16,9.56a5.57,5.57,0,0,1-5.55,5.57,5.68,5.68,0,0,1-2.3-.5c-.17-.09-.34-.17-.49-.26a1,1,0,0,0-.52-.15,1.14,1.14,0,0,0-.4.08l-1.83.79.79-1.83A1,1,0,0,0,5.64,12.34ZM18.3,16.26l.79,1.83-1.83-.79a1,1,0,0,0-.92.06,5.69,5.69,0,0,1-6-.23h.06A7.58,7.58,0,0,0,18,9.56c0-.12,0-.23,0-.35a5.52,5.52,0,0,1,1.13,3.35,5.32,5.32,0,0,1-.76,2.78A1,1,0,0,0,18.3,16.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.9ba93bedd002f8ae1b3791340c6d8179.svg";
export { ForwardRef as ReactComponent };